import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react'
import { Label } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/Store';

const DocumentHeaderLogo = () => {
    const { poStore } = useStore();
    const { loadingPO, currentPurchaseOrder } = poStore;

    if (currentPurchaseOrder === null || loadingPO) {
        return <Fragment />
    }
    return (
        <div className='hlogo'>
            <img
                className='hlogo__imagestyle'
                src='/assets/logo.png'
                alt='BriskMfg Inc.'
            />
            {currentPurchaseOrder.po_invoice_no && (
                <Label className='hlogo__documentNumber' color='blue'>{currentPurchaseOrder.po_invoice_no}</Label>
            )}
        </div>
    )
}

export default observer(DocumentHeaderLogo)
